// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"ac42c638","394":"836220ff","474":"10dfcd05","499":"5aba265c","519":"056593ab","668":"cc6a3a7c","729":"ed26201d"}[chunkId] + ".js";
};